module.exports = __webpack_public_path__ + "static/media/BridalImg.52cce03f.jpg";